import Address from '@/plugins/sdk/resources/Address'

export const FILTER = function (address, asHtml) {
  let text = ''

  if (address instanceof Address) {
    if (asHtml) {
      text = `
        ${address.organisation_name ? address.organisation_name + '<br>' : ''}
        ${address.first_name ? address.first_name + ' ' + address.last_name + '<br>' : ''}
        ${address.address_line1 ? address.address_line1 + '<br>' : ''}
        ${address.address_line2 ? address.address_line2 + '<br>' : ''}
        ${address.locality} ${address.administrative_area} ${address.postal_code}
      `
    } else {
      const fields = [
        'organisation_name',
        'first_name',
        'last_name',
        'address_line1',
        'address_line2',
        'locality',
        'administrative_area',
        'country'
      ]

      let stringList = []

      fields.map(field => {
        stringList.push(text[field] || '-')
      })

      stringList = stringList.filter(s => s !== '-')

      text = stringList.join(', ')
    }
  }

  return text
}

export default {
  install (Vue) {
    Vue.filter('address', FILTER)
  }
}
